import { Module, getModule, VuexModule, MutationAction, Mutation } from 'vuex-module-decorators';
import store from '@/store';
import { FilterRequestType } from '@/entity/common/filters.types'
import { IProductsTaxItem } from '@/entity/warehouse/Products/Tax/Tax.types'
import { prepareFormData } from '@/store/utils/formDataHelper'

@Module({
    namespaced: true,
    name: 'ProductsTax',
    store,
    dynamic: true
})
class ProductsTaxModule extends VuexModule {
    public productsTax:IProductsTaxItem[] | null = null
    ready = false

    @MutationAction
    async fetchAll(data?: FilterRequestType): Promise<{ productsTax:IProductsTaxItem[]}>{
        const productsTax = await store.$repository.products_tax.fetchAll(prepareFormData(data));
        return { productsTax }
    }
    @Mutation
    async setReady(st:boolean){
        this.ready = st
    }
}

export const ProductsTaxStore = getModule(ProductsTaxModule)